import * as Ramda from 'ramda';
import mergeGlobalValuesIntoState from './globalValues';
import mergeCoveragesIntoState from './coverages';
import mergeQuoteCoveragesIntoState from './quote/coverages';
import mergeQuoteGlobalsIntoState from './quote/globals';
import mergeUWRatingModifiersIntoState from './uw/ratingOptions';
import mergeRaterOptionsIntoState from './uw/raterOptions';
import mergeExcessTowerIntoState from './uw/excessTower';
import uwUiSettingsBuilder from './uw/uiSettingsBuilder';
import mergeCategoryCustomizationsIntoState from './quote/categories';
import mergeUiSettingsIntoState from './uiSettings';
import mergeComponentCoveragesIntoState from './componentCoverages';
import mergeUwComponentRateModifiersIntoState from './uw/componentRateModifiers';
import mergeComponentGlobalsIntoState from './componentGlobals';
import { mergeReferralReasonsForEditIntoQuoteState } from './quote/mergeQuoteReferralReasonsForEdit';

export const simpleQuoteFormatters = Ramda.pipe(mergeUiSettingsIntoState);

export const customizeQuoteFormatters = Ramda.pipe(
  mergeGlobalValuesIntoState,
  mergeCoveragesIntoState,
  mergeUWRatingModifiersIntoState,
  mergeComponentCoveragesIntoState,
  mergeComponentGlobalsIntoState,
  mergeUwComponentRateModifiersIntoState,
  mergeUiSettingsIntoState
);

export const editQuoteFormatters = Ramda.pipe(
  mergeQuoteGlobalsIntoState,
  mergeQuoteCoveragesIntoState,
  mergeUWRatingModifiersIntoState,
  mergeCategoryCustomizationsIntoState,
  mergeComponentCoveragesIntoState,
  mergeComponentGlobalsIntoState,
  mergeUwComponentRateModifiersIntoState,
  mergeUiSettingsIntoState
);

export const underwriteQuoteFormatters = Ramda.pipe(
  mergeRaterOptionsIntoState,
  mergeQuoteGlobalsIntoState,
  mergeExcessTowerIntoState,
  mergeComponentGlobalsIntoState,
  mergeQuoteCoveragesIntoState,
  mergeComponentCoveragesIntoState,
  mergeUWRatingModifiersIntoState,
  mergeUwComponentRateModifiersIntoState,
  mergeReferralReasonsForEditIntoQuoteState,
  uwUiSettingsBuilder,
  mergeCategoryCustomizationsIntoState,
  mergeUiSettingsIntoState
);
